import ChecklistComponent, {
  ChecklistComponentProps,
} from './ChecklistComponent';

export default ChecklistComponent;

export type { ChecklistComponentProps };
